import { useLocation } from '@tanstack/react-router';
import { AppLink } from '../app-link';
import { useShellTexts } from '../i18n/use-shell-texts';
import { primaryButton, secondaryButton } from './buttons';
import { StatusPage } from './status-page';

const HOME = '/dashboard';

/** A guard refused the page (`/unauthorized`). */
export function UnauthorizedPage() {
  const t = useShellTexts().unauthorized;
  return (
    <StatusPage title={t.title} message={t.message}>
      <button type="button" className={secondaryButton} onClick={() => window.history.back()}>
        {t.goBack}
      </button>
      <AppLink href={HOME} className={primaryButton}>
        {t.goHome}
      </AppLink>
    </StatusPage>
  );
}

/** The feature is not bought, or switched off at this node (`/unavailable?reason=`). */
export function UnavailablePage({ reason }: { reason: string | null | undefined }) {
  const t = useShellTexts().unavailable;
  const message =
    reason === 'tenant_disabled'
      ? t.tenantDisabled
      : reason === 'orgnode_disabled'
        ? t.orgNodeDisabled
        : t.unknown;
  return (
    <StatusPage title={t.title} message={message}>
      <AppLink href={HOME} className={primaryButton}>
        {t.goHome}
      </AppLink>
    </StatusPage>
  );
}

/** An address the portal does not know. */
export function NotFoundPage() {
  const t = useShellTexts().notFound;
  return (
    <StatusPage title={t.title} message={t.message}>
      <AppLink href={HOME} className={primaryButton}>
        {t.goHome}
      </AppLink>
    </StatusPage>
  );
}

/**
 * A page the backend navigation lists but this app does not have yet: link to the same address
 * in the Angular portal, so both can be used side by side during the migration.
 */
export function LegacyPage({ legacyBaseUrl }: { legacyBaseUrl: string | null }) {
  const t = useShellTexts().legacy;
  const location = useLocation();
  const target = legacyBaseUrl
    ? `${legacyBaseUrl.replace(/\/+$/, '')}${location.pathname}${location.searchStr}`
    : null;
  return (
    <StatusPage title={t.title} message={target ? t.message : `${t.message} ${t.notLinked}`}>
      {target ? (
        <a href={target} className={primaryButton}>
          {t.open}
        </a>
      ) : null}
    </StatusPage>
  );
}
